import { useState } from "react";
import { Box } from "@mui/material";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "./firebase";
import "./LogIn.css";
import { Link, useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";

const SignIn = () => {
  const alert = useAlert();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const welcomeUrl = process.env.REACT_APP_SITE_ON_LOGGED_IN_NAVIGATE_URL;
  const onLogin = (event) => {
    event.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        alert.show("Log in successful " + " \n\n Click Ok to continue ....");
        navigate(welcomeUrl);
      })
      .catch((error) => {
        alert.show("Invalid Login !");
      });
  };
  const Register = (e) => {
    e.preventDefault();
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        alert.show(
          user.email +
            " was created successfully \n\nClick OK or Close to continue"
        );
        navigate("/Home");
      })
      .catch((error) => {
        // console.log(error.message);
        alert.show("User not created !\n\n");
      });
  };
  return (
    <div className="login">
      <div className="login_container" style={{ backgroundColor: "#FF3131" }}>
        <h1> Log in</h1>
        <form>
          <h5>E-mail</h5>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <h5>Password</h5>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            className="login_signInButton"
            type="submit"
            title="if you have already created an account please enter the existing email and password to log in"
            onClick={(event) => onLogin(event)}
          >
            Log In
          </button>
          <button
            title="Any email and password you enter will create the new account if it doesn't exist"
            className="login_registerButton"
            onClick={Register}
          >
            Create A New Account
          </button>
          <p>
            By continuing, you agree to
            {` ${process.env.REACT_APP_SITE_DOMAIN_NAME}  `} Conditions of Use
            and Privacy Notice.
          </p>
          <div>
            <Link to="/ForgotPassword" className="link">
              <h2>Forgot your password ?</h2>
            </Link>
          </div>
          <Link to="/">
            <div className="close">Close</div>
          </Link>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
